/* eslint-disable react/jsx-curly-newline */
/* eslint-disable camelcase */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import IconConfused from 'assets/images/feedback/icon-confuso.svg';
import IconHappy from 'assets/images/feedback/icon-feliz.svg';
import IconIndifferent from 'assets/images/feedback/icon-indiferente.svg';
import IconUnsatisfied from 'assets/images/feedback/icon-insatisfeito.svg';
import IconSatisfied from 'assets/images/feedback/icon-satisfeito.svg';
import Api from 'services/api';
import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from 'store';
import Loader from 'components/atoms/loader';
import {
  MenusBehaviourState,
  MenusBehaviourTypes,
} from 'store/modules/menus_behaviour_store/types';
import Style from './styles';

const FeedbackModal = () => {
  const { menus_behaviour } = useSelector<ApplicationState, MenusBehaviourState>(
    (state) => state.session.menus_behaviour,
  );
  const [selectedMood, setSelectedMood] = useState<string | null>(null);
  const [suggestion, setSuggestion] = useState<string>('');
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [sended, setSended] = useState<boolean>(false);
  const { pathname } = useLocation();
  const dispatch = useDispatch();

  const handleSendClick = () => {
    setIsLoading(true);
    Api.post('/feedbacks', {
      feedback: suggestion,
      score: selectedMood,
      feature_name: menus_behaviour.pathname === '' ? pathname : menus_behaviour.pathname,
    }).then((response) => {
      if (response.status === 201) {
        setIsLoading(false);
        setSended(true);
        setSuggestion('');
        setSelectedMood(null);
      }
    });
  };

  const handleConfirmationClick = () => {
    dispatch({ type: MenusBehaviourTypes.CLOSE_FEEDBACK_MODAL });
    setSended(false);
  };

  return (
    <Modal show={menus_behaviour.feedbackModal} style={Style.modal}>
      <div className="modal-header">
        <h4 className="modal-title text-nowrap">
          <strong>
            Ajude-nos a melhorar noss
            {menus_behaviour.pathname === '' ? 'o serviço' : 'a ferramenta'}
          </strong>
        </h4>
        <button
          aria-label="Close"
          className="close"
          data-dismiss="modal"
          type="button"
          onClick={() => dispatch({ type: MenusBehaviourTypes.CLOSE_FEEDBACK_MODAL })}
        >
          <span aria-hidden="true">×</span>
        </button>
      </div>

      {!isLoading && !sended && (
        <>
          <div className="modal-body" style={Style.modalBody}>
            <h5 className="mb-2">
              <strong>
                Qual o seu nível de satisfação{' '}
                {menus_behaviour.pathname === '' ? '' : ` com o ${menus_behaviour.pathname}`}?
              </strong>
            </h5>
            <div className="button-icon-group" style={Style.buttonIconGroup}>
              <div
                className="button-icon"
                style={
                  selectedMood === 'insatisfeito' ? Style.buttonIconSelected : Style.buttonIcon
                }
                onClick={() => setSelectedMood('insatisfeito')}
              >
                <img width={30} height={30} src={IconUnsatisfied} alt="" />
                <p style={Style.label}>INSATISFEITO</p>
              </div>

              <div
                className="button-icon"
                style={selectedMood === 'confuso' ? Style.buttonIconSelected : Style.buttonIcon}
                onClick={() => setSelectedMood('confuso')}
              >
                <img width={30} height={30} src={IconConfused} alt="" />
                <p style={Style.label}>CONFUSO</p>
              </div>

              <div
                className="button-icon"
                style={selectedMood === 'indiferente' ? Style.buttonIconSelected : Style.buttonIcon}
                onClick={() => setSelectedMood('indiferente')}
              >
                <img width={30} height={30} src={IconIndifferent} alt="" />
                <p style={Style.label}>INDIFERENTE</p>
              </div>

              <div
                className="button-icon"
                style={selectedMood === 'satisfeito' ? Style.buttonIconSelected : Style.buttonIcon}
                onClick={() => setSelectedMood('satisfeito')}
              >
                <img width={30} height={30} src={IconSatisfied} alt="" />
                <p style={Style.label}>SATISFEITO</p>
              </div>

              <div
                className="button-icon"
                style={selectedMood === 'feliz' ? Style.buttonIconSelected : Style.buttonIcon}
                onClick={() => setSelectedMood('feliz')}
              >
                <img width={30} height={30} src={IconHappy} alt="" />
                <p style={Style.label}>FELIZ</p>
              </div>
            </div>
            <p>
              {menus_behaviour.pathname === ''
                ? 'Sua sugestão:'
                : `Como está sendo utilizar o ${menus_behaviour.pathname}`}
            </p>
            <textarea
              style={Style.textarea}
              rows={8}
              value={suggestion}
              onChange={(event) => setSuggestion(event.target.value)}
              className="p-2"
            />
            <div>Escolha uma opção e escreva sua experiência para enviar.</div>
          </div>
          <div className="modal-footer">
            <button
              className="btn btn-secondary"
              type="button"
              onClick={() => dispatch({ type: MenusBehaviourTypes.CLOSE_FEEDBACK_MODAL })}
            >
              Cancelar
            </button>
            <button
              onClick={() => handleSendClick()}
              type="button"
              className="btn btn-primary btn-submit-modal"
              disabled={!selectedMood || suggestion === ''}
            >
              Enviar
            </button>
          </div>
        </>
      )}
      {isLoading && (
        <div className="py-5">
          <Loader />
        </div>
      )}
      {sended && (
        <>
          <div className="modal-body">
            <div className="alert alert-success text-center mb-0">
              Enviado com sucesso! Agradecemos sua colaboração.
            </div>
          </div>
          <div className="modal-footer">
            <button
              className="btn btn-secondary"
              type="button"
              onClick={() => handleConfirmationClick()}
            >
              Ok
            </button>
          </div>
        </>
      )}
    </Modal>
  );
};

export default FeedbackModal;
